<script>
import dayjs from 'dayjs/esm'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

export default {
  // Properties returned from data() become reactive state
  // and will be exposed on `this`.
  data() {
    return {
      calendrier_fr: {
        closeText: 'Fermer',
        prevText: 'Précédent',
        nextText: 'Suivant',
        currentText: "Aujourd'hui",
        monthNames: [
          'janvier',
          'février',
          'mars',
          'avril',
          'mai',
          'juin',
          'juillet',
          'août',
          'septembre',
          'octobre',
          'novembre',
          'décembre'
        ],
        monthNamesShort: [
          'janv.',
          'févr.',
          'mars',
          'avr.',
          'mai',
          'juin',
          'juil.',
          'août',
          'sept.',
          'oct.',
          'nov.',
          'déc.'
        ],
        dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        weekHeader: 'Sem.',
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
      },
      dateRecu: '',
      dateDeRendu: '',
      computationWasSamediOrDimanche: '',
      selectedCanton: { name: 'Vaud', code: 'VD' },
      cantons: [
        // { name: 'Fribourg', code: 'FR' },
        { name: 'Vaud', code: 'VD' }
        //   { name: 'Berne', code: 'BE' },
        //  { name: 'Genève', code: 'GE' },
        // { name: 'Neuchâtel', code: 'NE' },
        // { name: 'Jura', code: 'JU' },
        // { name: 'Valais', code: 'VS' }
      ],
      vaud: [
        {
          annee: 2024,
          feries: [
            { date: '01.01.2024' },
            { date: '02.01.2024' },
            { date: '29.03.2024' },
            { date: '01.04.2024' },
            { date: '09.05.2024' },
            { date: '20.05.2024' },
            { date: '01.08.2024' },
            { date: '16.09.2024' },
            { date: '25.12.2024' }
          ]
        },
        {
          annee: 2025,
          feries: [
            { date: '01.01.2025' },
            { date: '02.01.2025' },
            { date: '18.04.2025' },
            { date: '21.04.2025' },
            { date: '29.05.2025' },
            { date: '09.06.2025' },
            { date: '01.08.2025' },
            { date: '22.09.2025' },
            { date: '25.12.2025' }
          ]
        },
        {
          annee: 2026,
          feries: [
            { date: '01.01.2026' },
            { date: '02.01.2026' },
            { date: '03.04.2026' },
            { date: '06.04.2026' },
            { date: '14.05.2026' },
            { date: '25.05.2026' },
            { date: '01.08.2026' },
            { date: '21.09.2026' },
            { date: '25.12.2026' }
          ]
        }
      ],
      fribourg: [{ date: 'Fribourg' }],
      berne: [{ date: 'Fribourg' }],
      geneve: [{ date: 'Fribourg' }],
      neuchatel: [{ date: 'Fribourg' }],
      jura: [{ date: 'Fribourg' }],
      valais: [{ date: 'Fribourg' }],
      units: [
        { name: 'Jour(s)', key: 'J' },
        { name: 'Mois - pas fonctionnel pour le moment', key: 'M' }
      ],
      selectedUnit: 'Jour(s)',
      number: 1,
      items: [
        {
          label: 'Point de départ'
        },
        {
          label: 'Suspension'
        },
        {
          label: 'Weekend'
        },
        {
          label: 'Jours fériés'
        }
      ],
      suspensions: true,
      feriesList: [],
      suspensionsList: [],
      weekendList: [],
      events: [
        {
          status: 'Date de notification (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-shopping-cart',
          color: '#274eb0'
        },
        {
          status: 'Date de départ (art. 142 I CPC et 146 I CPC)',
          date: '',
          icon: 'pi pi-cog',
          color: '#eca549'
        },
        {
          status: 'Suspension (art. 145 et 146 CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        },
        { status: 'Férié (art. 142 III CPC)', date: '', icon: 'pi pi-check', color: '#eca549' },
        {
          status: 'Samedi ou dimanche (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        },
        {
          status: 'Computation finale',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        }
      ]
    }
  },

  // Methods are functions that mutate state and trigger updates.
  // They can be bound as event handlers in templates.
  methods: {
    calculate: function (
      internDateDep,
      internCanton,
      internUnite,
      internSuspensions,
      internNombre
    ) {
      if (internDateDep == '' || internCanton == '') {
        //TODO SHOW THAT THE USER HAVE TO CHOOSE A Date
        return
      }

      let internDateNotifDaysJs = dayjs(internDateDep)

      this.resetEvents(internSuspensions)

      if (internUnite === 'Jour(s)') {
        //set jour notif
        this.events.at(0).date = internDateNotifDaysJs.format('ddd DD.MM.YYYY')

        // set jour de départ = jour notif +1
        let internDateDepDaysJs = internDateNotifDaysJs.add(1, 'day')
        this.events.at(1).date = internDateDepDaysJs.format('ddd DD.MM.YYYY')

        let dateCalcule
        let dateFinale
        if (internSuspensions == true) {
          this.events.at(2).date = this.suspensionsList
          this.events.at(3).date = this.feriesList
          this.events.at(4).date = this.weekendList
          //avec suspension et pas moins 1 car le for commence  1).
          dateCalcule = this.calulerJourAvecSuspension(internDateDepDaysJs, internNombre)
          dateFinale = this.checkSiDateFinalEstPasSuspenduOuFerieOuWeekend(
            dateCalcule,
            this.getFeriesByCanton(internCanton.name)
          )
        } else {
          this.events.at(2).date = this.feriesList
          this.events.at(3).date = this.weekendList
          //sans suspension et moins 1 car on compte le jour de départ.
          dateCalcule = internDateDepDaysJs.add(internNombre - 1, 'day')
          dateFinale = this.checkSiDateFinalEstPasFerieOuWeekend(
            dateCalcule,
            this.getFeriesByCanton(internCanton.name)
          )
        }
        // SHOW FINAL COMPUTATION
        this.events.at(this.events.length - 1).date = dateFinale.format('ddd DD.MM.YYYY')
      } else if (internUnite === 'Mois') {
        //TODO pour les mois il y a tout a faire

        let moisInternDateDepDayjs = internDateNotifDaysJs.add(internNombre, 'month')
        let rr = this.checkWeekend(moisInternDateDepDayjs)
        this.dateDeRendu = rr.format('ddd DD.MM.YYYY')
      }
    },
    calulerJourAvecSuspension: function (internDate, number) {
      let insideDate = internDate

      //NOEL ANNE PASSE [18.12.yyyy-1 à 02.01.yyyy] inclus, on peut pas finir sur le 18.12 ni sur le 02.01
      let debutNoelAnneePassee = dayjs()
      debutNoelAnneePassee = debutNoelAnneePassee.set('year', insideDate.get('year') - 1)
      debutNoelAnneePassee = debutNoelAnneePassee.set('month', 11)
      debutNoelAnneePassee = debutNoelAnneePassee.set('date', 18)
      let finNoelAnnePassee = dayjs()
      finNoelAnnePassee = finNoelAnnePassee.set('year', insideDate.get('year'))
      finNoelAnnePassee = finNoelAnnePassee.set('month', 0)
      finNoelAnnePassee = finNoelAnnePassee.set('date', 2)
      //const totalNoelAnneePassee=16;

      //PAQUE [7j avant paques et 7 jours après paques] y compris donc 15 j total. exemple 2024 : paques est le 31.03, donc on peut pas finir le 24.03 et ni le 07.04.
      // a savoir que le 23.03 est un samedi alors non plus le 23 mais ça cest testé dans une autre fonction.
      let paqueArray = this.getEaster(insideDate.year())
      let paque = dayjs()
      //only in this order first year than month than day
      paque = paque.set('year', insideDate.year())
      paque = paque.set('month', paqueArray.at(0) - 1)
      paque = paque.set('date', paqueArray.at(1))
      let debutPaque = dayjs(paque)
      debutPaque = debutPaque.subtract(7, 'day')
      let finPaque = dayjs(paque)
      finPaque = finPaque.add(7, 'day')
      //const totalPaque=15;

      //ETE [15.07.yyyy à 15.08.yyyy] inclus, on peut pas finir sur le 15.07 ni sur le 15.08
      let debutEte = dayjs()
      debutEte = debutEte.set('year', insideDate.get('year'))
      debutEte = debutEte.set('month', 6)
      debutEte = debutEte.set('date', 15)
      let finEte = dayjs()
      finEte = finEte.set('year', insideDate.get('year'))
      finEte = finEte.set('month', 7)
      finEte = finEte.set('date', 15)
      //const totalEte=32;

      //NOEL [18.12.yyyy à 02.01.yyyy+1] inclus, on peut pas finir sur le 18.12 ni sur le 02.01
      let debutNoel = dayjs()
      debutNoel = debutNoel.set('year', insideDate.get('year'))
      debutNoel = debutNoel.set('month', 11)
      debutNoel = debutNoel.set('date', 18)
      let finNoel = dayjs()
      finNoel = finNoel.set('year', insideDate.get('year') + 1)
      finNoel = finNoel.set('month', 0)
      finNoel = finNoel.set('date', 2)
      //const totalNoel=16;

      // CTRL SI LE JOUR DE DEPART EST DEJA SUSPENDU ET PASSE AUSSI LORSQUE RECUR DEMANDE DE CHECK SI DERNIER JOUR EST SUSPENDU ?
      insideDate = this.dateDepartEstDejaSuspendu(
        insideDate,
        debutNoelAnneePassee.format('YYYY-MM-DD'),
        finNoelAnnePassee.format('YYYY-MM-DD'),
        finNoelAnnePassee,
        debutPaque.format('YYYY-MM-DD'),
        finPaque.format('YYYY-MM-DD'),
        finPaque,
        debutEte.format('YYYY-MM-DD'),
        finEte.format('YYYY-MM-DD'),
        finEte,
        debutNoel.format('YYYY-MM-DD'),
        finNoel.format('YYYY-MM-DD'),
        finNoel,
        number
      )
      console.log(number)
      for (let i = 1; i < number; i++) {
        //TODO annee précedente noel ???? comme function depart deja suspendu

        console.log('je passe dans le for' + number)
        if (insideDate.add(1, 'day').isSame(debutPaque, 'day')) {
          //si ça tombe sur le 7e jour avant paque alors on passe directement au 7e jour après paque
          this.addToListOnce(
            this.suspensionsList,
            insideDate.add(1, 'day').format('ddd DD.MM.YYYY') +
              '-' +
              finPaque.format('ddd DD.MM.YYYY')
          )

          insideDate = finPaque
          insideDate = insideDate.add(1, 'day')

          //this.events.at(2).date =this.events.at(2).date + ' Pâques ' + insideDate.get('year') + ', '
        } else {
          if (insideDate.add(1, 'day').isSame(debutEte, 'day')) {
            //si ça tombe sur le 15-07-aaaa alors on passe directement a 15-08-aaaa.
            this.addToListOnce(
              this.suspensionsList,
              insideDate.add(1, 'day').format('ddd DD.MM.YYYY') +
                '-' +
                finEte.format('ddd DD.MM.YYYY')
            )

            insideDate = finEte
            insideDate = insideDate.add(1, 'day')
            //this.events.at(2).date = this.events.at(2).date + ' Été ' + insideDate.get('year') + ', '
          } else {
            if (insideDate.add(1, 'day').isSame(debutNoel, 'day')) {
              //pour que l'année soit juste il faut le mettre ici car fin noel est deja année prochaine.
              //this.events.at(2).date = this.events.at(2).date + ' Noël ' + insideDate.get('year') + ', '
              this.addToListOnce(
                this.suspensionsList,
                insideDate.add(1, 'day').format('ddd DD.MM.YYYY') +
                  '-' +
                  finNoel.format('ddd DD.MM.YYYY')
              )

              //si ça tombe sur le 18-12-aaaa alors on passe directement a 02-01-aaaa.
              insideDate = finNoel
              insideDate = insideDate.add(1, 'day')

              //ajoute un ans à chaque suspension
              paqueArray = this.getEaster(insideDate.year())
              paque = paque.set('year', insideDate.year())
              paque = paque.set('month', paqueArray.at(0) - 1)
              paque = paque.set('date', paqueArray.at(1))
              debutPaque = dayjs(paque).subtract(7, 'day')
              finPaque = dayjs(paque).add(7, 'day')
              debutEte = debutEte.set('year', insideDate.get('year'))
              finEte = finEte.set('year', insideDate.get('year'))
              debutNoel = debutNoel.set('year', insideDate.get('year'))
              finNoel = finNoel.set('year', insideDate.get('year') + 1)
            } else {
              insideDate = insideDate.add(1, 'day')
            }
          }
        }
      }
      return insideDate
    },
    dateDepartEstDejaSuspendu: function (
      insideDate,
      aFormatDebutNoelAnneePassee,
      bFormatFinNoelAnneePassee,
      finNoelAnnePassee,
      aFormatDebutPaque,
      bFormatFinPaque,
      finPaque,
      aFormatDebutEte,
      bFormatFinEte,
      finEte,
      aFormatDebutNoel,
      bFormatFinNoel,
      finNoel,
      number
    ) {
      //Methode qui indidique si le jour de départ est enfaite deja dans une suspension.
      if (
        insideDate.isBetween(aFormatDebutNoelAnneePassee, bFormatFinNoelAnneePassee, null, '[]')
      ) {
        //depart est suspendu par Noel année passée
        this.addToListOnce(
          this.suspensionsList,
          insideDate.format('ddd DD.MM.YYYY') + '-' + finNoelAnnePassee.format('ddd DD.MM.YYYY')
        )

        insideDate = finNoelAnnePassee.add(1, 'day')

        if (number > 0) {
          this.events.at(1).date = insideDate.format('ddd DD.MM.YYYY')
        }
        return insideDate
      } else {
        if (insideDate.isBetween(aFormatDebutPaque, bFormatFinPaque, null, '[]')) {
          //depart est suspendu par Paques
          this.addToListOnce(
            this.suspensionsList,
            insideDate.format('ddd DD.MM.YYYY') + '-' + finPaque.format('ddd DD.MM.YYYY')
          )
          insideDate = finPaque.add(1, 'day')

          if (number > 0) {
            this.events.at(1).date = insideDate.format('ddd DD.MM.YYYY')
          }
          return insideDate
        } else {
          if (insideDate.isBetween(aFormatDebutEte, bFormatFinEte, null, '[]')) {
            //depart est suspendu par Ete
            this.addToListOnce(
              this.suspensionsList,
              insideDate.format('ddd DD.MM.YYYY') + '-' + finEte.format('ddd DD.MM.YYYY')
            )
            insideDate = finEte.add(1, 'day')

            if (number > 0) {
              this.events.at(1).date = insideDate.format('ddd DD.MM.YYYY')
            }
            return insideDate
          } else {
            if (insideDate.isBetween(aFormatDebutNoel, bFormatFinNoel, null, '[]')) {
              this.addToListOnce(
                this.suspensionsList,
                insideDate.format('ddd DD.MM.YYYY') + '-' + finNoel.format('ddd DD.MM.YYYY')
              )
              //depart est suspendu par Noel
              insideDate = finNoel.add(1, 'day')

              if (number > 0) {
                this.events.at(1).date = insideDate.format('ddd DD.MM.YYYY')
              }
              return insideDate
            }
          }
        }
      }
      return insideDate
    },
    getEaster: function (year) {
      var f = Math.floor,
        // Golden Number - 1
        G = year % 19,
        C = f(year / 100),
        // related to Epact
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        // number of days from 21 March to the Paschal full moon
        I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
        // weekday for the Paschal full moon
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        // number of days from 21 March to the Sunday on or before the Paschal full moon
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4)
      return [month, day]
    },
    getFeriesByCanton: function (canton) {
      switch (canton) {
        case 'Vaud':
          return this.vaud

        case 'Fribourg':
          return this.fribourg

        case 'Berne':
          return this.berne

        case 'Valais':
          return this.valais

        case 'Jura':
          return this.jura

        case 'Neuchâtel':
          return this.neuchatel

        case 'Genève':
          return this.geneve
      }
    },
    checkFerie: function (date, joursFeriesByCanton) {
      console.log(date.format('DD.MM.YYYY'))
      //TODO check back end car a la mano cest chiant
      let annee
      //trouve bonnne annee et compare les feriés de l'année YYYY avec la date DD.MM.YYYY
      for (let i = 0; i < joursFeriesByCanton.length; i++) {
        if (joursFeriesByCanton.at(i).annee == date.year()) {
          annee = i
        }
      }
      //annee est trouvé alors parcours les féries de cette année en cours et check si date == a un ferié.
      if (annee != undefined || annee != null) {
        for (let i = 0; i < joursFeriesByCanton.at(annee).feries.length; i++) {
          let dayToTest = dayjs(joursFeriesByCanton.at(annee).feries.at(i).date, 'DD.MM.YYYY')
          if (date.isSame(dayToTest, 'day')) {
            console.log('isSame')
            console.log(date.format('DD.MM.YYYY') + ' ' + dayToTest.format('DD.MM.YYYY'))
            this.addToListOnce(this.feriesList, date.format('ddd DD.MM.YYYY'))
            return date.add(1, 'day')
          }
        }
      }
      return date
    },
    checkWeekend: function (date) {
      //fonction qui retourne le lundi si on tombe sur un samedi ou un dimanche.
      this.computationWasSamediOrDimanche = null
      // si le jour tombe sur un samedi repousse au lundi.
      if (date.day() === 6) {
        //  console.log('samedi')
        this.addToListOnce(this.weekendList, date.format('ddd DD.MM.YYYY'))
        this.addToListOnce(this.weekendList, date.add(1, 'day').format('ddd DD.MM.YYYY'))
        this.computationWasSamediOrDimanche =
          'Le dernier jour est ' + date.format('ddd DD.MM.YYYY').toString() + ' --> report au :'
        // console.log(date.add(2, 'day'))
        return date.add(2, 'day')
      }
      // si le jour tombe sur un dimanche repousse au lundi.
      else if (date.day() === 0) {
        // console.log('dimanche')
        this.addToListOnce(this.weekendList, date.format('ddd DD.MM.YYYY'))
        this.computationWasSamediOrDimanche =
          'Le dernier jour est ' + date.format('ddd DD.MM.YYYY').toString() + ' --> report au :'
        //   console.log(date.add(1, 'day'))
        return date.add(1, 'day')
      }
      return date
    },

    checkSiDateFinalEstPasSuspenduOuFerieOuWeekend: function (date, joursFeriesByCanton) {
      //condition de sortie de la boucle recursive: si la date du ctrl de suspension == a date ok && la date du ctrl Ferie == a date ok && si la date ctrl du weekend == a date ok
      if (
        this.calulerJourAvecSuspension(date, 0) == date &&
        this.checkFerie(date, joursFeriesByCanton) == date &&
        this.checkWeekend(date) == date
      ) {
        return date
      }
      if (this.calulerJourAvecSuspension(date, 0) != date) {
        console.log('avec suspensions, recurs suspendu')
        console.log(date.format('DD.MM.YYYY'))
        return this.checkSiDateFinalEstPasSuspenduOuFerieOuWeekend(
          this.calulerJourAvecSuspension(date, 0),
          joursFeriesByCanton
        )
      }
      if (this.checkFerie(date, joursFeriesByCanton) != date) {
        console.log('avec suspensions, recurs ferie')
        return this.checkSiDateFinalEstPasSuspenduOuFerieOuWeekend(
          this.checkFerie(date, joursFeriesByCanton),
          joursFeriesByCanton
        )
      }
      if (this.checkWeekend(date) != date) {
        console.log('avec suspensions, recurs weekend')
        return this.checkSiDateFinalEstPasSuspenduOuFerieOuWeekend(
          this.checkWeekend(date),
          joursFeriesByCanton
        )
      }
    },
    checkSiDateFinalEstPasFerieOuWeekend: function (date, joursFeriesByCanton) {
      console.log(date)
      console.log(joursFeriesByCanton)
      //condition de sortie de la boucle recursive: si la date du ctrl Ferie == a date ok && si la date ctrl du weekend == a date ok
      if (this.checkFerie(date, joursFeriesByCanton) == date && this.checkWeekend(date) == date) {
        return date
      }
      if (this.checkFerie(date, joursFeriesByCanton) != date) {
        console.log('sans suspensions, recurs ferie')
        return this.checkSiDateFinalEstPasFerieOuWeekend(
          this.checkFerie(date, joursFeriesByCanton),
          joursFeriesByCanton
        )
      }
      if (this.checkWeekend(date) != date) {
        console.log('recurs weekend')
        return this.checkSiDateFinalEstPasFerieOuWeekend(
          this.checkWeekend(date),
          joursFeriesByCanton
        )
      }
    },
    addToListOnce: function (tab, date) {
      if (!tab.includes(date)) {
        tab.push(date)
      }
    },
    resetEvents: function (isSuspendu) {
      this.weekendList = []
      this.suspensionsList = []
      this.feriesList = []
      this.events = []
      if (isSuspendu) {
        this.events.push({
          status: 'Date de notification (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-shopping-cart',
          color: '#274eb0'
        })
        this.events.push({
          status: 'Date de départ (art. 142 I CPC et 146 I CPC)',
          date: '',
          icon: 'pi pi-cog',
          color: '#eca549'
        })
        this.events.push({
          status: 'Suspension (art. 145 et 146 CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Férié (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Samedi ou dimanche (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
        this.events.push({
          status: 'Computation finale',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
      } else {
        this.events.push({
          status: 'Date de notification (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-shopping-cart',
          color: '#274eb0'
        })
        this.events.push({
          status: 'Date de départ (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-cog',
          color: '#eca549'
        })
        this.events.push({
          status: 'Férié (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Samedi ou dimanche (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
        this.events.push({
          status: 'Computation finale',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
      }
    },
    onChangeSuspension(event) {
      console.log(event)
      this.events = []
      if (event == false) {
        this.events.push({
          status: 'Date de notification (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-shopping-cart',
          color: '#274eb0'
        })
        this.events.push({
          status: 'Date de départ (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-cog',
          color: '#eca549'
        })
        this.events.push({
          status: 'Férié (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Samedi ou dimanche (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
        this.events.push({
          status: 'Computation finale',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
      }
      if (event == true) {
        this.events.push({
          status: 'Date de notification (art. 142 I CPC)',
          date: '',
          icon: 'pi pi-shopping-cart',
          color: '#274eb0'
        })
        this.events.push({
          status: 'Date de départ (art. 142 I CPC et 146 I CPC)',
          date: '',
          icon: 'pi pi-cog',
          color: '#eca549'
        })
        this.events.push({
          status: 'Suspension (art. 145 et 146 CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Férié (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#eca549'
        })
        this.events.push({
          status: 'Samedi ou dimanche (art. 142 III CPC)',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
        this.events.push({
          status: 'Computation finale',
          date: '',
          icon: 'pi pi-check',
          color: '#10b981'
        })
      }
    }
  },

  // Lifecycle hooks are called at different stages
  // of a component's lifecycle.
  // This function will be called when the component is mounted.
  mounted() {}
}
</script>
<template>
  <div class="content">
    <Card style="width: 25em">
      <template #title> Calcul du délai de procédure civile </template>
      <template #subtitle> CPC </template>
      <template #content>
        <p class="m-0">
          Insérez la date de notification afin de calculer le délai final. Les fériés sont
          comptabilisé depuis le 1er janvier 2024 jusqu'au 31.12.2026 inclus.
        </p>
        <div class="flex flex-wrap justify-content-center gap-3">
          <Calendar
            v-model="dateRecu"
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="Jour de la notification / reçu le "
          />

          <Dropdown
            v-model="selectedCanton"
            :options="cantons"
            optionLabel="name"
            placeholder="Canton"
            class="w-full md:w-14rem"
          />

          <div class="flex align-items-center">
            <Checkbox
              v-model="suspensions"
              :binary="true"
              @change="onChangeSuspension(suspensions)"
            />
            <label class="ml-2"> Suspensions </label>
          </div>

          <div v-for="unity in units" :key="unity.key" class="flex align-items-center">
            <RadioButton
              v-model="selectedUnit"
              :inputId="unity.key"
              name="dynamic"
              :value="unity.name"
            />
            <label :for="unity.key" class="ml-2">{{ unity.name }}</label>
          </div>

          <label for="minmax-buttons" class="font-bold block mb-2"> Nombre </label>
          <InputNumber
            v-model="number"
            inputId="minmax-buttons"
            mode="decimal"
            showButtons
            :min="1"
            :max="1000"
          />
        </div>
      </template>
      <template #footer>
        <Button
          icon="pi pi-calculator"
          label="Calcule"
          @click="calculate(dateRecu, selectedCanton, selectedUnit, suspensions, number)"
        />
      </template>
    </Card>

    <Card style="width: 40em">
      <template #title> Computation </template>
      <template #subtitle> CPC </template>
      <template #content>
        <div>
          {{ computationWasSamediOrDimanche }}<br />
          <b style="color: red"> {{ dateDeRendu }}<br /></b>
          <br />
          <br />

          <Timeline :value="events">
            <template #opposite="slotProps">
              <small class="p-text-secondary">{{ slotProps.item.date }}</small>
            </template>
            <template #content="slotProps">
              {{ slotProps.item.status }}
            </template>
          </Timeline>
        </div>
      </template>
    </Card>
  </div>
</template>

<style>
.content {
  display: flex;
  justify-content: space-around;
}
</style>
